import {
  Component,
  Input,
  ViewChild,
  OnInit,
  ViewContainerRef,
  Output,
  EventEmitter,
} from "@angular/core";

import { SliderPanelDatasource, Slider } from "@/shared-module/models";

@Component({
  selector: "app-sliderpanel",
  templateUrl: "sliderpanel.component.html",
})
export class SliderPanelComponent implements OnInit {
  @Input() data: SliderPanelDatasource;
  @Input() min: number = 0;
  @ViewChild("template", { static: true }) template;
  @Output() sliderchanged: EventEmitter<Slider> = new EventEmitter();

  constructor(private viewContainerRef: ViewContainerRef) {}

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
  }

  changed(slider: Slider) {
    this.sliderchanged.emit(slider);
  }
}
